import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Banner from '../components/Banner';
import FilterSidebar from '../components/FilterSidebar';
import Deals from '../components/Deals';
import Footer from '../components/Footer';
import VerificationPopup from '../components/VerificationPopup';
import { useAuth } from '../context/AuthContext';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
  Checkbox,
  FormControlLabel,
  Slider,
  Divider,
  Box,
  Button,
  IconButton,
   Collapse,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField
} from '@mui/material';
import cartService from '../service/cartService';
import { useCart } from '../context/CartContext';
import {fetchFilteredProducts} from '../service/filterService';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import addressService from "../service/addressService";
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';

const UserDashboard = () => {
  
    const { t } = useTranslation();
const navigate = useNavigate();
const { loadCartFromServer } = useCart();
    const isMobile = useMediaQuery('(max-width:768px)');
  const { user , refreshUser } = useAuth();
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
    pincode
  } = user || {};

const [sidebarOpen, setSidebarOpen] = useState(false);

const toggleSidebar = () => {
  setSidebarOpen(prev => !prev);
};
  
  


  
  
  
 const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
 /* const [filters, setFilters] = useState({
    brands: [],
    priceRange: [0, 1000],
  });*/

 /* const handleSelectCategory = (category, subCategory) => {
    setSelectedCategory(category);
    setSelectedSubCategory(subCategory);
  };*/
  
    
    const [openAddressDialog, setOpenAddressDialog] = useState(false);
  const [addressFormData, setAddressFormData] = useState({
    userId: userId,
    street1: "",
    street2: "",
    city: "Chennai",
    state: "Tamil Nadu",
    postalCode: "",
    country: "India",
    email: email || "",
    phone: "",
  });

    const [page, setPage] = useState(0);
const [pageSize, setPageSize] = useState(12);
  const [filters, setFilters] = useState({ brands: [], priceRange: [0, 5000], customerPincode: pincode, inventoryStatus: ["AVAILABLE", "BACKORDERED"] } );
  const [filteredProducts, setFilteredProducts] = useState([]);
const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  
  
 /* async function fetchFilteredAllProducts(page, pageSize){
         const res = await fetchFilteredProducts(filters,page, pageSize);
     setFilteredProducts(res.data.content);
        setTotal(res.data.totalElements);
  }*/
  

  async function fetchFilteredAllProducts(currentPage, currentSize) {
    if (isLoading) return;
    setIsLoading(true);
    
    try {
        // Pass the current state values
        const res = await fetchFilteredProducts(filters, currentPage, currentSize); 
        
        const newProducts = res.data.content;
        const newTotal = res.data.totalElements;

        // 🔥 FIX 1: Use the functional update to APPEND products
        setFilteredProducts(prevProducts => {
            // If it's the first page (page 0), replace the list.
            if (currentPage === 0) {
                return newProducts; 
            } else {
                // For all subsequent pages, append the new products.
                return [...prevProducts, ...newProducts];
            }
        });
        
        // Update the total count
        setTotal(newTotal);

    } catch (error) {
        console.error("Error fetching products:", error);
    } finally {
        setIsLoading(false);
    }
}
  
    
  const handleSelectCategory = (category, subCategory) => {
    
    setSelectedCategory(category);
    setSelectedSubCategory(subCategory);
    
    console.log("category ", category);
     console.log("subCategory ", subCategory);
     setPage(0); 
    
  setFilters({ brands: [], priceRange: [0, 5000], searchTxt: "", subCategories: [subCategory], categories: [category] , customerPincode: pincode, inventoryStatus: ["AVAILABLE", "BACKORDERED"]});
/*  setFilters((prevFilters) => ({
        ...prevFilters,
        subCategories: [subCategory],
        categories: [category],
      })); */

  };
  
  const handleOnSearch = (searchQuery) => {
      setPage(0); 
    setFilters({brands: [], priceRange: [0, 5000], 
        searchTxt: searchQuery, customerPincode: pincode, inventoryStatus: ["AVAILABLE", "BACKORDERED"]
      });
  };

  useEffect(() => {
      if (!pincode || pincode.trim() === "") {
      setOpenAddressDialog(true);
    }
    // Always start from page 0 when initial filters or location change
    setPage(0);
   // fetchFilteredAllProducts(page, pageSize);
     loadCartFromServer();
  }, [pincode, filters]);
  
  // Handles Page Change (Load More)
useEffect(() => {
  
   if (!filters) return; 
  
    // Only fetch if the page state or pageSize changes (excluding the initial reset)
    // The 'pincode' and 'filters' change will trigger the fetch via the 'page: 0' change
    fetchFilteredAllProducts(page, pageSize);
}, [page, pageSize,filters]);

  

  
  const handleSaveAddress = async () => {
    if (!addressFormData.postalCode) {
      alert("Please enter your postal code before proceeding.");
      return;
    }
  if(!addressFormData.street1 || !addressFormData.city || !addressFormData.state || !addressFormData.country || !addressFormData.email || !addressFormData.postalCode){
      alert("Please fill all the details!");
      return;
    }
    
    try {
      addressFormData.userId= user.userId;
      await addressService.saveSelectedAddress(userId, addressFormData); 
       const updatedUser = await refreshUser();
      
     // console.log("updated user "+ updatedUser.pincode);
    
      if(updatedUser?.pincode){
         setFilters({ brands: [], priceRange: [0, 5000], searchTxt: "" , customerPincode: addressFormData.postalCode, inventoryStatus: ["AVAILABLE", "BACKORDERED"]});
     setOpenAddressDialog(false);
      }
     
    } catch (error) {
      console.error("Error saving address:", error);
      alert("Failed to save address. Please try again.");
    }
  };

  return (
    <>
      <Header onSearch={handleOnSearch} />
      
         <Menu onSelectCategory={handleSelectCategory} />

      <Box display="flex"  sx={{ 
      maxWidth: '100%', 
      overflowX: 'hidden', // Prevents the "Deals" section from pushing the page wide
      minHeight: '100vh' 
    }}>
        
{!isMobile && (
  <>
      {/* Sidebar with toggle arrow */}
      <Collapse in={sidebarOpen} orientation="horizontal">
        <Box
          sx={{
            width: 150,
            borderRight: "1px solid #ddd",
            position: "relative",
            backgroundColor: "#fafafa",
            height: "100vh",
                fontSize: {
    xs: '0.65rem', // ~12px (Mobile/Small Tablet)
    sm: '0.7rem',  // ~13px (Large Tablet)
    md: '0.775rem' // ~14px (Desktop)
  },
          }}
        >
          <FilterSidebar
            filters={filters}
            setFilters={setFilters}
            onApplyFilters={fetchFilteredAllProducts}
          />

          {/* Arrow button inside sidebar */}
          <IconButton
            onClick={toggleSidebar}
            sx={{
              position: "absolute",
              top: "50%",
              right: -20,
              transform: "translateY(-50%)",
              backgroundColor: "white",
              border: "1px solid #ccc",
              "&:hover": { backgroundColor: "#f0f0f0" }
            }}
            size="small"
          >
            <ChevronLeftIcon />
          </IconButton>
        </Box>
      </Collapse>

      {/* Collapsed toggle button */}
      {!sidebarOpen && (
        <IconButton
          onClick={toggleSidebar}
          sx={{
            position: "relative",
            backgroundColor: "white",
            border: "1px solid #ccc",
            height: "40px",
            marginTop: "20px",
            "&:hover": { backgroundColor: "#f0f0f0" }
          }}
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      )}
        </>
)}

        {/* Main Content */}
      <Box component="main"  sx={{ 
        flexGrow: 1, 
        p: { xs: 1, sm: 2, md: 3 }, // Reduced padding on mobile
        width: '100%',
        overflowX: 'hidden', // Extra safety for the grid negative margin
        boxSizing: 'border-box'
      }}>
     
      {/* <Deals
            selectedCategory={selectedCategory}
            selectedSubCategory={selectedSubCategory}
            filters={filters}
          /> */}
    
         <Deals products={filteredProducts} />
                <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', // 🔥 Changed from 'flex-end' to 'center'
              mt: 4 // Increased Margin Top for spacing
            }}
          >
<Button
    onClick={() => setPage(prevPage => prevPage + 1)} // Assuming you correctly use setPage now
    
    // 🔥 FIX 2: Compare current loaded length against total
    disabled={isLoading || filteredProducts.length >= total}
sx={{ 
    fontWeight: 'bold', 
    fontSize: { 
      xs: '0.9rem', // Mobile
      sm: '1.2rem', // Tablet
      md: '1.5rem'  // Desktop
    } 
  }}
>
    {/* 🔥 Updated using the t() function with English strings as fallbacks */}
  {isLoading 
    ? t('loading', 'Loading...') // Looks for the key 'loading', defaults to 'Loading...'
    : t('load_more', 'Load More') // Looks for the key 'load_more', defaults to 'Load More'
  }
</Button>
</Box>
         
        </Box>
      </Box>
   <Footer />
           
              <Dialog
        open={openAddressDialog}
        disableEscapeKeyDown
        aria-labelledby="address-dialog-title"
        PaperProps={{
          sx: { width: "600px", borderRadius: "12px", p: 2 },
        }}
      >
        <DialogTitle id="address-dialog-title">Complete Your Address Details</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <TextField
              label="Street Line 1"
              value={addressFormData.street1}
              onChange={(e) => setAddressFormData({ ...addressFormData, street1: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
              required
            />
            <TextField
              label="Street Line 2"
              value={addressFormData.street2}
              onChange={(e) => setAddressFormData({ ...addressFormData, street2: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="City"
              value={addressFormData.city}
              onChange={(e) => setAddressFormData({ ...addressFormData, city: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
              required
            />
            <TextField
              label="State"
              value={addressFormData.state}
              onChange={(e) => setAddressFormData({ ...addressFormData, state: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
              required
            />
            <TextField
              label="Zip Code"
              value={addressFormData.postalCode}
              onChange={(e) => setAddressFormData({ ...addressFormData, postalCode: e.target.value })}
              fullWidth
              required
              sx={{ mb: 2 }}
              required
            />
            <TextField
              label="Country"
              value={addressFormData.country}
              onChange={(e) => setAddressFormData({ ...addressFormData, country: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
              required
            />
            <TextField
              label="Email ID"
              value={addressFormData.email}
              onChange={(e) => setAddressFormData({ ...addressFormData, email: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Contact Number"
              value={addressFormData.phone}
              onChange={(e) => setAddressFormData({ ...addressFormData, phone: e.target.value })}
              fullWidth
              required
            />
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 3 }}
              onClick={handleSaveAddress}
            >
              Save Address
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      </>
  );
};

export default UserDashboard;
